const HOSTNAME = 'https://enroll.korphildavao.site';
const PROJECT = 'oems';
const API_URL = 'https://api.enroll.korphildavao.site';
const API_KEY = 'Flkx9YeAa%mrNWac%c7*h^SQ$sB%5rpJ';
const UPLOAD_URL = HOSTNAME + '/uploads';

module.exports = Object.freeze({
    PROJECT,
    UPLOAD_URL,
    API_KEY,
    API: {
        BASE_URL: HOSTNAME,
        AUTHENTICATE: API_URL + '/authenticate',
        COURSE: API_URL + '/course',
        REGISTER: API_URL + '/register',
        REGISTRATION: API_URL + '/registration',
        LOGIN: API_URL + '/login',
        LOGOUT: API_URL + '/logout',
        VERIFY: API_URL + '/verify',
        ADDRESS: API_URL + '/address',
        EXAM: API_URL + '/exam',
        QUESTION: API_URL + '/question',
        USER: API_URL + '/user',
        SMS: API_URL + '/sms',
        UPLOAD: API_URL + '/upload',
    },
    ROUTE: {
        HOME: 'home',
        LOGIN: 'login',
        SMS: 'sms',
        ENROLL: 'enroll',
        REGISTER: 'register',
        REGISTRATIONS: 'registrations',
        SIDS: 'sids',
        EXAM: 'exam',
        COURSES: 'courses',
        EXAMS: 'exams',
        QUESTIONS: 'questions',
        USERS: 'users',
        REQUIREMENTS: 'requirements',
        ANNOUNCEMENTS: 'announcements',
        BSRS: 'bsrs',
        SCHOLARSHIPS: 'scholarships',
        HEALTH: 'healthProtocol',
        REGISTRATION_REPORT: 'registrationReport',
        ENROLLEE_REPORT: 'enrolleeReport',
    },
    USER: {
        ADMIN: 0,
        TEACHER: 1,
        REGISTRAR: 2,
        TRAINING: 3,
        IT: 4,
    },
    COURSE: {
        DIPLOMA: 1,
        SHORT_TERM: 2,
    },
    REGISTRATION_STATUS: {
        UNPROCESSED: 0,
        APPROVED: 1,
        REJECTED: 2,
        ENROLLED: 3,
    },
    FORM_STATUS: {
        CREATE: 'Create',
        UPDATE: 'Update',
        DELETE: 'Delete'
    },
    PERSONNEL: {
        CENTER_ADMINISTRATOR: {
            NAME: 'ENGR. CONSTANTINO B. PANES JR., Ed.D',
            TITLE: 'Center Administrator'
        },
        TRAINING_HEAD: {
            NAME: 'MARILOU F. COLOMA',
            TITLE: 'Head, Training Department'
        },
        CENTER_REGISTRAR: {
            NAME: 'MAJOR P. SALIPOT, RN, MPsy',
            TITLE: 'Center Registrar'
        },
    },
    SETTINGS: {
    }
});